import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import type { IModelResponse } from "../base/dto/base.dto";
import { ModelScopeMaster, type IModelCreateScopeMasterRequest } from "./dto/scope-master.dto";
import { ScopeMasterRepository } from "./scope-master.repository";

export class ScopeMasterService extends BaseService {
  private scopeMasterRepository = new ScopeMasterRepository(this.api, this.configService);

  async getScopeMaster(params: any): Promise<IModelResponse<ModelScopeMaster[]>> {
    let dataResult: IModelResponse<ModelScopeMaster[]> = {
          data: [],
    };
    const { $functions } = useNuxtApp()
    try {
      const res = await this.scopeMasterRepository.getScopeMaster(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map(e => new ModelScopeMaster(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getScopeMaster', resData.data, dataResult)
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true
      });
      console.log(err, ScopeMasterService.name);
    }
    return dataResult;
  }

  async getScopeMasterById(id: string | number): Promise<ModelScopeMaster> {
    let dataResult: ModelScopeMaster = new ModelScopeMaster();
    const { $functions } = useNuxtApp()
    try {
      const res = await this.scopeMasterRepository.getScopeMasterById(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelScopeMaster(resData.data);
        console.log('getScopeMaster', resData.data, dataResult)
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true
      });
      console.log(err, ScopeMasterService.name);
    }
    return dataResult;
  }

  async createScopeMaster(params: IModelCreateScopeMasterRequest): Promise<ModelScopeMaster | undefined> {
    let dataResult
    const { $functions } = useNuxtApp()
    try {
      const res = await this.scopeMasterRepository.createScopeMaster(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelScopeMaster(resData.data)
        console.log('createScopeMaster', resData.data, dataResult)
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true
      });
      console.log(err, ScopeMasterService.name);
    }
    return dataResult;
  }

  async updateScopeMaster(params: IModelCreateScopeMasterRequest): Promise<ModelScopeMaster | undefined> {
    let dataResult
    const { $functions } = useNuxtApp()
    try {
      const res = await this.scopeMasterRepository.updateScopeMaster(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelScopeMaster(resData.data)
        console.log('updateScopeMaster', resData.data, dataResult)
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true
      });
      console.log(err, ScopeMasterService.name);
    }
    return dataResult;
  }
  
}
